module.exports = __webpack_public_path__ + "static/media/bt-entries-square.e9063b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-entries-square.png
// module id = 668
// module chunks = 0